import React, { useEffect, useState } from "react";

import HelpModal from "components/Modal/HelpModal";
import Modals from "./Modals";

import s from "./MainUI.module.scss";
import cx from "classnames";

import EventBus from "scripts/util/EventBus";
import { toggleRecordButton } from "scripts/util/8thwall";

import StickImage from "assets/images/dogmented/stick.png";
import BallImage from "assets/images/dogmented/ball.png";
import RecenterIcon from "assets/images/dogmented/recenter.svg";
import CameraIcon from "assets/images/dogmented/flip-camera.svg";
// import ActiveCameraIcon from "assets/images/dogmented/active-flip-camera.svg";
import MenuIcon from "assets/images/dogmented/menu.png";
const url =
  process.env.NODE_ENV === "development"
    ? `https://${window.location.hostname}:3000/gestures`
    : `https://${window.location.hostname}/gestures`;

export default function MainUI({
  showToys,
  modals,
  setModals,
  unlockedTricks,
  lockMenu,
  showArrowAnimation,
  tutorialStepState,
}) {
  const [debug, setDebug] = useState("");

  // const [cameraActive, setCameraActive] = useState(true);
  const [helpActive, setHelpActive] = useState(false);
  const [cameraFlipped, setCameraFlipped] = useState(false);

  useEffect(() => {
    const DEBUG = EventBus.on("Debug", handleDebug);
    const ACTION = EventBus.on("Action", handleAction);
    toggleRecordButton(true);
    return () => {
      toggleRecordButton(false);
      ACTION.off();
      DEBUG.off();
    };
  }, []);

  useEffect(() => {
    if (lockMenu) {
      setHelpActive(false);
    }
  }, [lockMenu]);

  const handleDebug = (payload) => {
    setDebug(payload);
  };

  const handleAction = (payload) => {
    if (payload.type === "cameraFlipComplete") {
      // setCameraActive(true);
    }
    if (payload.type === "help") {
      alert(payload.type + " " + payload.value);
    }
  };

  const handleCameraFlip = () => {
    // setCameraActive(false);
    setCameraFlipped((val) => !val);
    emitAction("cameraFlipStart");
  };

  const handleHelp = () => {
    if (helpActive) {
      setHelpActive(false);
    } else {
      setHelpActive(true);
    }
  };

  const closeModal = () => {
    setHelpActive(false);
  };

  function emitAction(name) {
    EventBus.dispatch("Action", { type: name });
  }

  return (
    <div className={s.mainui}>
      <div className={s.header}>
        {!lockMenu && !helpActive && !cameraFlipped && (
          <img
            src={MenuIcon}
            alt="Help Icon"
            className={cx(s.menuIcon)}
            onClick={handleHelp}
          />
        )}
        {helpActive && (
          <div
            className={cx(s.help, { [s.active]: helpActive })}
            onClick={handleHelp}
          ></div>
        )}
        {helpActive && (
          <HelpModal
            closeModal={closeModal}
            unlockedTricks={unlockedTricks}
            lockMenu={lockMenu}
            modals={modals}
            setModals={setModals}
          />
        )}
        <div
          className={s.recenter}
          style={{ visibility: cameraFlipped ? "hidden" : "visible" }}
          onClick={(e) => emitAction("recenter")}
        >
          <img src={RecenterIcon} alt="Recenter" />
          <span>Recenter</span>
        </div>
      </div>
      <div
        className={cx(s.iframeContainer)}
        style={{ opacity: showArrowAnimation ? "1" : "0" }}
      >
        <iframe
          className={s.arrowIframe}
          title="animation"
          src={`${url}/Arrow-Toy.html`}
          scrolling="no"
          frameBorder="0"
        ></iframe>
      </div>
      <Modals modals={modals} />
      <div className={s.debug}>{debug}</div>
      <div className={s.footer}>
        <div
          className={cx(s.toys)}
          style={{
            display: showToys === "hide" ? "none" : "block",
            opacity: showToys === "disabled" ? "0.3" : "1",
          }}
        >
          <div className={s.stick}>
            <img
              src={StickImage}
              alt="Stick"
              onClick={(e) => emitAction("stick")}
            />
          </div>
          <div className={s.ball}>
            <img
              src={BallImage}
              alt="Ball"
              onClick={(e) => emitAction("ball")}
            />
          </div>
        </div>
        <div className={cx(s.camera, s.active)} onClick={(e) => handleCameraFlip()}>
          {/* {!cameraActive || tutorialStepState !== 8 ? (
            <img src={CameraIcon} alt="Flip Camera Inactive" />
          ) : (
            <img src={ActiveCameraIcon} alt="Flip Camera Active" />
          )} */}
          <img src={CameraIcon} alt="Flip Camera Active" />
        </div>
      </div>
    </div>
  );
}
